import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { FinancialItemWithLabelContainerModel, FinancialItemWithLabelQueryCriteria } from '../../../../../../models/aggregates/erp/financial';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemCodeService extends BaseApiTemplateService<FinancialItemWithLabelContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory/item-codes';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'inventory/item-codes';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'inventory/item-codes';
    this.httpClient = http;
  }

  public postByCriteriaPromise(queryCriteria: FinancialItemWithLabelQueryCriteria, visa: ApiVisa):
    Promise<PagingResponseModel<FinancialItemWithLabelContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/query';
    return this.httpClient.post<PagingResponseModel<FinancialItemWithLabelContainerModel>>(
      Url,
      queryCriteria,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public upload(model: FinancialItemWithLabelContainerModel, visa: ApiVisa):
    Promise<ApiResponseModel<FinancialItemWithLabelContainerModel>> {
    return this.httpClient.post<ApiResponseModel<FinancialItemWithLabelContainerModel>>(
      this.apiUrl + '/upload',
      model,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public exportCsv(queryCriteria: FinancialItemWithLabelQueryCriteria, apiVisa: ApiVisa): Observable<Blob> {
    return this.httpClient.post<Blob>(
      this.apiUrl + '/export/csv',
      queryCriteria,
      {
        headers: new HttpHeaders({
          authorization: apiVisa.jwt_secret,
          responseType: 'blob',
          tenantCode: apiVisa.tenantCode,
          appId: '10'
        }),
        responseType: 'blob' as 'json'
      });
  }

  public postByCategory(itemCodeFromCategoryDto: any, visa: ApiVisa): Observable<ApiResponseModel<Blob>> {
    let apiUrl = this.apiUrl
    if (this.endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<Blob>>(
      apiUrl + '/item-code-category/backoffice-ep',
      itemCodeFromCategoryDto,
      this.getHttpHeader(visa)
    )
  }
}
